module.exports = __webpack_public_path__ + "img/category-card.dad871f1.png";